import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import Table from "../../NewTable";
import DownloadButton from "../../DownloadButton";
import useIsAr from "../../../Hooks/useIsAr";
import { formatDate, getStatusKPIName } from "../../../helpers";

function KPIAttachments({ attachments, KPIDetails, getData }) {
  const [isAr, locale] = useIsAr();
  const requestStatuses = useSelector(
    ({ theme }) => theme.WorkflowStatus.item.Items
  );
  const isPercent = KPIDetails.UnitOfMeasure === "Percentage";
  const suffix = isPercent
    ? "%"
    : isAr
    ? KPIDetails.ArabicUnitDetails
    : KPIDetails.EnglishUnitDetails;

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      key: "name",
      header: <FormattedMessage id="attatchment-name" />,
      cell: "FileName",
      width: "75%",
    },
    {
      header: <FormattedMessage id="attatchment-upload-date" />,
      cell: (item) => formatDate(item?.Created),
      width: "15%",
    },
    // {
    //   header: <FormattedMessage id="common.update-kpi-value" />,
    //   cell: (item) => (item.Value ? `${item.Value} ${suffix}` : '---'),
    //   width: '15%'
    // },
    // {
    //   header: <FormattedMessage id="common.status" />,
    //   cell: (item) =>
    //     item.Status !== null
    //       ? getStatusKPIName(requestStatuses, item.Status?.toString(), locale)
    //       : '---',
    //   width: '15%'
    // }
  ];

  const actions = [(item) => <DownloadButton file={item} />];

  return (
    <div className="attachment-section" style={{ margin: "0 32px" }}>
      <Table
        data={attachments}
        columns={columns}
        actions={actions}
        actionsHeader={<FormattedMessage id="kpi-attachment.action" />}
      />
    </div>
  );
}

export default KPIAttachments;
